import { virtualDir } from "#skyward_global";
import { getCallbackStore, getCallbackStoreFacade } from "./skyward.ui.callbackStore";
import { CallbackStore, DetailsPanelEventData } from "./types";

const skyward = window.skyward;

const onTranslatedInternal: CallbackStore<() => void> = getCallbackStore();
export const onTranslated = getCallbackStoreFacade(onTranslatedInternal);
export const englishCanaryText = "My hovercraft is full of eels.";

const timeout: (callback: () => void) => void = window.requestIdleCallback ?? ((callback) => setTimeout(callback, 2500));
timeout(() =>
{
    const title = $("title");
    const canary = $("#translationCanary");

    let currentLanguage: string = document.documentElement.lang;
    let currentCanaryText: string = canary.text();
    let currentMSTHash: string | null = null;

    const observer = new MutationObserver(test);
    observer.observe(document.documentElement,
        {
            attributes: true,
            attributeFilter: ["lang"],
        });

    // Edge does not alter the HTML element when translating instead it alters every element with text.
    // Using the title here because it should always be translated.
    observer.observe(title[0],
        {
            attributes: true,
            attributeFilter: ["_msthash"],
        });

    // characterData alone isn't enough: see https://stackoverflow.com/a/33521527/9118790
    // In practice, subtree seems to be more reliable
    observer.observe(canary[0],
        {
            characterData: true,
            subtree: true,
        });


    let translationData: { lang: string, canary: string; };

    test();

    function test()
    {
        const language = document.documentElement.lang;
        const mstHash = title.attr("_msttexthash") ?? null; // coalescing to null so we do not also have to deal with undefined
        const canaryText = canary.text();

        if (currentLanguage !== language || currentMSTHash !== mstHash || currentCanaryText !== canaryText)
        {
            currentLanguage = language;
            currentMSTHash = mstHash;
            currentCanaryText = canaryText;

            // If we are in Chrome the "currentLanguage" can get set to "auto" if the user selected the "Auto Detect" option
            const documentLanguageChanged = (!/en\b/.test(currentLanguage) && currentLanguage != "auto");
            const canaryTextChanged = currentCanaryText !== englishCanaryText;
            const mstHashChanged = currentMSTHash != null;

            const languageChanged = documentLanguageChanged || canaryTextChanged || mstHashChanged;

            // We only want to post to the server if the "currentLanguage" or "currentCanaryText" have changed because
            // we can not determine what language the browser is translated to via the "currentMSTHash".
            //  - The "currentCanaryText" is used as a backup in case "currentLanguage" can not be used.
            //  - If we are in Edge and relying on the "currentMSTHash" the "currentCanaryText" should eventually get changed
            //    triggering a post to the server.
            //  - We can not rely solely on the "currentCanaryText" for edge because it could take a while for that to actually
            //    change and the logic in reportViewer.ts that is watching for translations needs to be quicker then that.
            const postLanguageChangeToServer = documentLanguageChanged || canaryTextChanged;

            if (postLanguageChangeToServer)
            {
                translationData =
                {
                    lang: currentLanguage,
                    canary: canaryText
                };
                postTranslation();

                // Do not try to do anything detailsPanel related if the detailsPanel JS is not loaded
                if (skyward.detailsPanel)
                {
                    tryPostDetailsPanel();
                    skyward.detailsPanel.eventCallbacks.contentLoaded.registerCallback((event: DetailsPanelEventData) => tryPostDetailsPanel(event));
                }

                // Do not try to do anything workflow related if the workflow JS is not loaded
                // @ts-ignore workflow doesn't have a .d.ts and we don't want to import this file
                // This allows us to use this method without including it in the bundle for pages that don't have the workflow module, while still providing enhanced functionality for pages that do
                if (skyward.workflow)
                {
                    tryPostWorkflow();
                    $(window).on("workflow-contentLoaded.translationDetector", () =>
                    {
                        tryPostWorkflow();
                    });
                }
            }

            if (languageChanged)
            {
                onTranslatedInternal.dispatchCallbacks();
            }
        }
    }
    function tryPostWorkflow()
    {
        // @ts-ignore workflow doesn't have a .d.ts and we don't want to import this file
        // This allows us to use this method without including it in the bundle for pages that don't have the workflow module, while still providing enhanced functionality for pages that do
        const workflowData = skyward.workflow.getTopMostWorkflowData();
        if (workflowData)
        {
            const { module, object, screen } = workflowData;
            postTranslation({ module, object, screen });
        }
    }
    function tryPostDetailsPanel(detailsPanelData?: any)
    {
        detailsPanelData ??= skyward.detailsPanel.isDetailsPanelOpen() ? skyward.detailsPanel.getData() : null;
        if (detailsPanelData)
        {
            const { module, object, screen } = detailsPanelData;
            postTranslation({ module, object, screen });
        }
    }
    function postTranslation(additionalData?: any)
    {
        $.ajax(`${virtualDir}SkySys/UserTranslation/Log`,
            {
                method: "POST",
                data: $.extend({}, translationData, additionalData),
                suppressErrors: true,
                activityIndicator: { silent: true }
            });
    }
});